export enum USER_ROLES {
  STUDENT = "0",
  PARENT = "100",
  TEACHER = "200",
  SKILL_COACH = "300",
  SCHOOL = "400",
  AMERICAU_ADMIN = "900",
}
export const ROLES: any = {
  "0": "Student",
  "100": "Parent",
  "200": "Teacher",
  "300": "Skill Coach",
  "400": "School Admin",
  "900": "AmericaU Admin",
};

export const isTeacher = (role: string | number): boolean => {
  return role >= USER_ROLES.TEACHER && role < USER_ROLES.SKILL_COACH;
};

export const isSkillCoach = (role: string | number): boolean => {
  return role >= USER_ROLES.SKILL_COACH && role < USER_ROLES.SCHOOL;
};

export const isParent = (role: string | number): boolean => {
  return role >= USER_ROLES.PARENT && role < USER_ROLES.TEACHER;
};

export const isSchoolAdmin = (role: string | number): boolean => {
  return role >= USER_ROLES.SCHOOL && role < USER_ROLES.AMERICAU_ADMIN;
};

export const isAmericaUAdmin = (role: string | number): boolean => {
  return role >= USER_ROLES.AMERICAU_ADMIN;
};

export const parseProgressURL = (url: string) => {
  if (import.meta.env.DEV) return "https://portal.americau.com" + url;
  return url;
};
